import React, { useState } from 'react';
import { BarChart2, List, ShirtIcon, TargetIcon } from 'lucide-react';
import Dashboard from './Dashboard.jsx';
import AdminOrders from './AdminOrders.jsx';
import AdminProducts from './AdminProducts.jsx';
import DatafromUsers from './DatafromUsers.jsx';

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const tabs = [
    { key: 'dashboard', label: 'Dashboard', icon: <BarChart2 size={18} className="mr-2" /> },
    { key: 'orders', label: 'Orders', icon: <List size={18} className="mr-2" /> },
    { key: 'data', label: 'Data', icon: <TargetIcon size={18} className="mr-2" /> },

    // { key: 'products', label: 'Products', icon: <ShirtIcon size={18} className="mr-2" /> },

  ];

  return (
    <div className="min-h-screen bg-black text-[#DBAE6E]">
      {/* Fixed Tab Header */}
      <div className="w-full bg-[#111111] border-b border-[#DBAE6E]/20 px-6 py-4 shadow-md">
        <div className="max-w-6xl mx-auto flex gap-2">
          {tabs.map(({ key, label, icon }) => (
            <button
              key={key}
              onClick={() => setActiveTab(key)}
              className={`flex items-center px-4 py-2 font-semibold text-sm uppercase tracking-widest rounded-xl transition-all ${
                activeTab === key
                  ? 'bg-[#DBAE6E] text-black'
                  : 'text-[#DBAE6E] hover:bg-[#222222]'
              }`}
            >
              {icon}
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="max-w-6xl mx-auto p-0">
        {activeTab === 'dashboard' && <Dashboard />}
        {activeTab === 'orders' && <AdminOrders />}
        {activeTab === 'data' && <DatafromUsers />}

        {/* {activeTab === 'products' && <AdminProducts />} */}

      </div>
    </div>
  );
};

export default AdminPanel;
